import type { ReactNode } from 'react';
import { useMsal } from '@azure/msal-react';
import { useLocation } from '@tanstack/react-router';
import { AdminChrome } from './admin-chrome';

/**
 * The admin console layout bound to MSAL: the operator identity + sign-out come
 * straight from the authenticated account so the shell always reflects who is
 * actually signed in. All presentation lives in `AdminChrome`.
 */
export function AdminShell({ children }: { children: ReactNode }) {
    const { instance, accounts } = useMsal();
    const account = accounts[0];
    const activePath = useLocation({ select: (location) => location.pathname });

    return (
        <AdminChrome
            operatorName={account?.name ?? account?.username ?? 'Operator'}
            operatorEmail={account?.username ?? ''}
            onSignOut={() => void instance.logoutRedirect()}
            activePath={activePath}
        >
            {children}
        </AdminChrome>
    );
}
